import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, MenuItem, TextField, InputAdornment, Icon, Typography } from "@mui/material";

function RelatedDropDown({ displayName, fieldRef, parentRef, options }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const [parentValue, setParentValue] = useState(null);
  const [opts, setOpts] = useState([]);

  function initListener() {
    // console.log(parentRef);
    const parentField = document.getElementById(`dff_${parentRef}`);
    if (parentField === null) {
      // console.log("NULLESTTTT");
      return;
    }
    parentField.addEventListener("change", function () {
      setParentValue(parentField.value);
    });
  }

  useEffect(() => {
    initListener();
  }, []);

  useEffect(() => {
    setSelectedOption(null);
    if (parentValue === null) {
      setOpts([]);
      return;
    }

    let tempOpts = options[parentValue];
    if (typeof tempOpts === "undefined") {
      tempOpts = [];
    }
    setOpts(tempOpts);
  }, [parentValue]);

  useEffect(() => {
    const watchField = document.getElementById(`dff_${fieldRef}`);
    watchField.dispatchEvent(new Event("change"));
  }, [selectedOption]);

  return (
    <Box mt={4}>
      <Box ml={0.5}>
        <Typography variant="h6" fontSize={14} fontWeight="light">
          {displayName}
        </Typography>
      </Box>
      <TextField
        select
        fullWidth
        // name={fieldRef}
        // label={displayName}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon>checklist</Icon>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{
          sx: {
            whiteSpace: "break-spaces",
          },
        }}
        onChange={(e) => {
          setSelectedOption(e.target.value);
        }}
        value={selectedOption}
      >
        {opts.map((option) => (
          <MenuItem value={option.value}>{option.name}</MenuItem>
        ))}
      </TextField>
      <input
        type="hidden"
        id={`dff_${fieldRef}`}
        name={fieldRef}
        value={selectedOption}
      />
    </Box>
  );
}

// Typechecking props of the Transaction
RelatedDropDown.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  parentRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  options: PropTypes.arrayOf(PropTypes.any),
};

RelatedDropDown.defaultProps = {
  options: null,
};
export default RelatedDropDown;
